import {
  Result,
  ResultSet,
  SearchDocument,
} from '@backstage/plugin-search-common';
import { z } from 'zod';
import { ConfigSchema as MarketplaceConfigSchema } from '@agilelab/plugin-wb-marketplace-common';

/**
 * Only technical rows from DB
 */
const witboostMarketplaceComputedInfoZod = z.object({
  kind: z.string(),
  taxonomy: z.object({
    name: z.string(),
    external_id: z.string(),
  }),
  in_data_contract_lineage: z.boolean().optional(),
  publishedAt: z.string().optional(),
  consumable: z.string().optional(),
  environment: z.string(),
  domain: z.object({
    name: z.string(),
    external_id: z.string(),
  }),
  owner: z.object({
    ref: z.string(),
    displayName: z.string(),
  }),
  parent: z
    .object({
      systemId: z.string(),
      parentComponentId: z.string().optional(),
      displayName: z.string(),
      parentComponentDisplayName: z.string().optional(),
    })
    .optional(),
});

export type WitboostMarketplaceComputedInfo = z.infer<
  typeof witboostMarketplaceComputedInfoZod
>;

const witboostMarketplaceSearchResultDataZod = z.intersection(
  z.object({
    _computedInfo: witboostMarketplaceComputedInfoZod,
    id: z.string(),
    documentId: z.string(),
  }),
  z.record(z.any()),
);

export type WitboostMarketplaceSearchResultData = z.infer<
  typeof witboostMarketplaceSearchResultDataZod
>;

export type WitboostMarketplaceSearchDocument =
  WitboostMarketplaceSearchResultData & SearchDocument;

export type WitboostMarketplaceSearchResult =
  Result<WitboostMarketplaceSearchDocument>;

export type WitboostMarketplaceSearchResultSet =
  ResultSet<WitboostMarketplaceSearchDocument>;

export type MarketplaceProjectConfigurationType =
  MarketplaceConfigSchema['search']['marketplace-projects']['filters'];
